/**
 * @param $resource
 * @param {ApiRequestParams} apiRequestParams
 * @param {AppConfig} appConfig
 */
const DeviceResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'devices/',
        Object.assign(
            apiRequestParams.defaults(),
            {
                deviceTime: () => (new Date()).toISOString(),
                eposVersion: appConfig.eposVersion,
                resolve: '*,deviceGroupItems,tablePlan',
            }
        ),
        {
            query: {
                isArray: true,
                method: 'GET',
                params: {
                    // Ensure no deviceGuid is sent with this request. It is usually
                    // sent with every request, from ApiRequestParams.defaults().
                    deviceGuid: '',
                },
                url: appConfig.apiBaseUrl + 'devices',
            },

            refresh: {
                method: 'GET',
                url: appConfig.apiBaseUrl + 'devices/current',
            },

            setGuid: {
                method: 'PUT',
                url: appConfig.apiBaseUrl + 'devices/:deviceID/guid',
            },
            clearGuid: {
                method: 'DELETE',
                url: appConfig.apiBaseUrl + 'devices/:deviceID/guid',
            },

            setPaymentTerminalConfig: {
                method: 'PATCH',
                url: appConfig.apiBaseUrl + 'devices/:deviceID',
            },
            setDeviceInfo: {
                method: 'PATCH',
                url: appConfig.apiBaseUrl + 'devices/:deviceID/info',
            },
            setUser: {
                method: 'PUT',
                url: appConfig.apiBaseUrl + 'devices/:deviceID/user',
            },
        }
    );
};

module.exports = DeviceResource;
